import { DELETE_ATTACHMENT } from "./types";
import AttachmentsApi from "../api/AttachmentsApi";

export const deleteAttachment = (courseId, id) => async dispatch => {
  try {
    await new AttachmentsApi().deleteAttachment(courseId, id);
    dispatch({
      type: DELETE_ATTACHMENT,
      payload: { courseId, id },
    });
  } catch (error) {
    if (error.response?.status === 403) {
      console.error("No tienes permisos para eliminar este material");
    } else {
      console.error("Error al eliminar el material", error);
    }
    throw error;
  }
};
